import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';

import { createEffect, Actions, ofType } from '@ngrx/effects';
import { tap, map } from 'rxjs/operators';

import * as fromAction from './router.action';

@Injectable()
export class RouterEffects {
  constructor(
    private actions$: Actions,
    private router: Router,
    private location: Location
  ) {}

  
  navigate$ = createEffect(() => this.actions$.pipe(
    ofType(fromAction.RouterActionType.RouterGo),
    map((action: fromAction.RouterGo) => action.payload),
    tap(({ path, query: queryParams, extras }) => {
      this.router.navigate(path, { queryParams, ...extras });
    })
  ), { dispatch: false });

  
  navigateBack$ = createEffect(() => this.actions$.pipe(
    ofType(fromAction.RouterActionType.RouterBack),
    tap(() => this.location.back()),
  ), { dispatch: false });

  
  navigateForward$ = createEffect(() => this.actions$.pipe(
    ofType(fromAction.RouterActionType.RouterForward),
    tap(() => this.location.forward()),
  ), { dispatch: false });

}
